import { Box } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from '../../lib/index';

export const Description = styled(Box, {})({
  display: 'none',
  overflow: 'hidden',
  marginBottom: 25,
  height: 120,

  textOverflow: 'ellipsis',
  whiteSpace: 'pre-wrap',

  WebkitLineClamp: '5',
  WebkitBoxOrient: 'vertical',

  [theme.breakpoints.up('laptop')]: {
    display: '-webkit-box',
  },
});
